import Image from 'next/image'

type Props = {
  color: string
  name: string
  iconUrl: string
}

const InviteStatus = ({ color, name, iconUrl }: Props) => (
  <div
    style={{ backgroundColor: color }}
    className="relative mt-12 flex w-fit items-center gap-4 rounded-16 py-2 pl-8 pr-4 text-white"
  >
    <Image src={iconUrl} alt={`Статус ${name}`} width={16} height={16} />
    <span className="relative -top-1 pr-5 font-bold text-16">{name}</span>
  </div>
)

export default InviteStatus
